const Sections = {
  IncomeAndSavings: 'Income & Savings',
  MonthlyDebtRepayments: 'Monthly Debt Repayments',
  ExpectedMonthlyHousingExpenses: 'Expected Monthly Housing Expenses',
  ClosingCosts: 'Closing Costs',
  Financing: 'Financing',
}

export default Sections;

export { Sections };